import { useLazyQuery } from '@apollo/client';
import { VStack, Button, HStack } from '@bpba/ui-components';
import { useState } from 'react';
import { Queries } from '../../rest/Queries';
import { validateQuery } from '../../rest/queries/validate.get';
import { VALIDATE_SUCCESS_MSG, VALIDATE_ERROR_MSG, VALIDATE_ERROR_FORMAT_MSG } from '../shared/Constantes';
import { StyledSpan } from '../shared/StyledSpan';
import styled from 'styled-components';

export const FormValidate = () => {
  const [dni, setDni] = useState('');
  const [resultValidate, setResultValidate] = useState<string | null>(null);

  const [runValidate, { loading }] = useLazyQuery<Queries>(validateQuery, {
    onCompleted: (query) => {
      const ok = !!query?.validate?.result;
      setResultValidate(ok ? VALIDATE_SUCCESS_MSG : VALIDATE_ERROR_MSG);
    },
    onError: () => {
      setResultValidate(VALIDATE_ERROR_FORMAT_MSG);
    },
  });

  const handleValidate = (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!dni || loading) return;

    setResultValidate(null);
    runValidate({ variables: { id: dni } });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDni(e.target.value.replace(/\D/g, ''));
  };

  return (
    <VStack mt={['50px', '100px']} alignItems={'center'}>
      <form onSubmit={handleValidate} style={{ width: '100%', height: '100%' }}>
        <StyledHStack height={['50px', '80px']} width={['100%']} maxWidth={['700px']} margin="auto">
          <StyledInput type="text" placeholder="Ingresá tu DNI" value={dni} onChange={handleChange} />

          <Button
            variant="primary"
            type="submit"
            fontSize={['initial', '20px']}
            maxWidth={['100px', '200px']}
            mt={'0px !important'}
            height={'100%'}
            disabled={loading || !dni}
          >
            {loading ? 'Validando…' : 'Validar'}
          </Button>
        </StyledHStack>
      </form>

      {resultValidate && (
        <StyledSpan
          fontSize={['initial', '20px']}
          lineHeight={['28px', '40px']}
          fontWeight={500}
          mt={['50px', '65px']}
          textAlign={'center'}
        >
          <div dangerouslySetInnerHTML={{ __html: resultValidate }} />
        </StyledSpan>
      )}
    </VStack>
  );
};

const StyledHStack = styled(HStack)({
  gap: '16px',
});

const StyledInput = styled.input`
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(14px) saturate(130%);
  -webkit-backdrop-filter: blur(14px) saturate(130%);
  font-size: 45px;
  border-bottom: 2px solid white !important;
  outline: none;
  padding: 20px !important;
  color: white !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  text-align: center;

  &::placeholder {
    font-size: 30px;
  }

  @media (max-width: 600px) {
    font-size: 24px;

    &::placeholder {
      font-size: 16px;
    }
  }
`;
